const toObject = (value) => (value && typeof value === "object" && !Array.isArray(value) ? value : {});

const toArray = (value) => (Array.isArray(value) ? value : []);

const toPositiveInt = (value, fallback) => {
  const parsed = Number(value);
  if (Number.isFinite(parsed) && parsed > 0) return Math.floor(parsed);
  return fallback;
};

const normalizePagination = (pagination = {}, fallback = {}) => {
  const page = toPositiveInt(pagination.page, toPositiveInt(fallback.page, 1));
  const pageSize = toPositiveInt(pagination.pageSize, toPositiveInt(fallback.pageSize, 25));
  const total = Math.max(0, Number(pagination.total) || Number(fallback.total) || 0);
  const totalPages = Math.max(
    0,
    toPositiveInt(pagination.totalPages, total > 0 ? Math.ceil(total / pageSize) : 0)
  );
  return { page, pageSize, total, totalPages };
};

export const normalizeBoosterManagementStudentsSummaryResponse = (payload = {}, fallback = {}) => {
  const root = toObject(payload?.data && typeof payload.data === "object" ? payload.data : payload);
  const students = toArray(root.students);
  const pagination = normalizePagination(root.pagination, {
    page: fallback.page,
    pageSize: fallback.pageSize,
    total: students.length,
  });
  const filters = toObject(root.filters);
  const dashboard = toObject(root.dashboard);
  return {
    available: root.available !== false,
    window: toObject(root.window),
    pagination,
    filters: {
      classId: filters.classId || null,
      sectionId: filters.sectionId || null,
      classLabel: filters.classLabel || filters.class || "",
      sectionLabel: filters.sectionLabel || filters.section || "",
      class: filters.class || "",
      section: filters.section || "",
    },
    summary: toObject(root.summary),
    dashboard: {
      healthSummary: toObject(dashboard.healthSummary),
      actionItems: toArray(dashboard.actionItems),
      classPerformance: toArray(dashboard.classPerformance),
      studentAttention: toArray(dashboard.studentAttention),
      studentAttentionTotal:
        Number(dashboard.studentAttentionTotal) ||
        toArray(dashboard.studentAttention).length,
      studentAttentionShown:
        Number(dashboard.studentAttentionShown) ||
        toArray(dashboard.studentAttention).length,
      studentAttentionTruncated:
        dashboard.studentAttentionTruncated === true,
      dataHealth: toObject(dashboard.dataHealth),
      historicalArchive: toObject(dashboard.historicalArchive),
      eligibility: toObject(dashboard.eligibility),
    },
    students,
  };
};
